// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-eafa58","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-d6935b","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-4c66fa"};